import React, { useState, useEffect, useCallback } from "react";
import { formatTime } from "../common/common";
import {Spin, Skeleton} from 'antd';
const TopSearches = ({ onApplyParams }) => {
  
  // const history = [
  //   {
  //     purpose: "CashOut",
  //     occupancy: "Primary",
  //     propertyValue: "500",
  //     fico: "700",
  //     ltv: "80%",
  //     createdTime: "2025-05-14 18:30:00",
  //   },
  //   {
  //     purpose: "Purchase",
  //     occupancy: "Primary",
  //     propertyValue: "500",
  //     fico: "700",
  //     ltv: "80%",
  //     createdTime: "2025-05-14 10:00:00",
  //   },
  //   {
  //     purpose: "Refinance",
  //     occupancy: "Primary",
  //     propertyValue: "500",
  //     fico: "700",
  //     ltv: "80%",
  //     createdTime: "2025-05-14 12:00:00",
  //   },
  //   {
  //     purpose: "CashOut",
  //     occupancy: "Primary",
  //     propertyValue: "500",
  //     fico: "700",
  //     ltv: "80%",
  //     createdTime: "2025-05-12 12:00:00",
  //   },
  //   {
  //     purpose: "CashOut",
  //     occupancy: "Primary",
  //     propertyValue: "500",
  //     fico: "700",
  //     ltv: "80%",
  //     createdTime: "2025-05-13 12:00:00",
  //   },
  // ];
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const formatHistory = (data) => {
    return data.map((item) => ({
      ...item,
      purpose: item.parameters.purpose || '',
      occupancy: item.parameters.occupancy || '',
      propertyValue: item.parameters.propertyValue || '', 
      fico: item.parameters.FICO || '',
      ltv: item.parameters.LTV || '',
      createdTime: item.created_at || '',
    }));
  };
  const fetchHistory = () => {
    setLoading(true);
    fetch("/los/priceengine/getsearchhistory", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("ZeitroA"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log('history: ',data);
        setHistory(formatHistory(data === null ? [] : data.slice(0, 8))); // history 最多展示8条（两行）
        setLoading(false);
      }).finally((() => {
        setLoading(false);
      }));
  };
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      }
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    }
  }
  const debouncedFetchHistory = useCallback(debounce(fetchHistory, 1000), []);
  useEffect(() => {
    debouncedFetchHistory();
  }, []);
  const [showTopSearches, setShowTopSearches] = useState(true);
  const close = () => {
    sessionStorage.setItem("showTopSearches", false);
    setShowTopSearches(false);
  };
  const applyParams = (params) => {
    // console.log('applyParams: ', params)
    // apply params to searchFields
    const finalParams = {
      ...params,
      isImpound: params.escrowWaiver ? true : false,
    }
    if(params.searchBy === "rate") {
      finalParams.targetRate = params.targetPrice
    }
    onApplyParams(finalParams)
  }
  const purposeTag = (purpose) => {
    return purpose === "Purchase" ? "Purchase" : purpose === "RateTermRefi" ? "Refinance" : "CashOut"
  }
  const getPropertyValue = (item) => {
    // console.log('item: ', item)
    return (item.parameters.loanAmount / item.parameters.LTV * 100)
  }
  const formatOccupancy = (occupancy) => {
    switch(occupancy){
      case "PRIMARY":
        return "Primary"
      case "SECOND_HOME":
        return "Second Home"
      case "INVESTMENT":
        return "Investment"
      default:
        return occupancy
    }
  }
  return (
    showTopSearches && (
      <div className="top-searches">
        <div className="title-box">
          <div className="title-box-left">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M9.99951 6.66667V10L11.6662 11.6667M2.54102 9.16672C2.72776 7.33344 3.5829 5.63307 4.94329 4.39003C6.30368 3.14699 8.07409 2.44829 9.91675 2.42725C11.7594 2.4062 13.5453 3.06428 14.9337 4.27592C16.3222 5.48756 17.2159 7.16796 17.4445 8.9965C17.6731 10.825 17.2204 12.6737 16.173 14.1899C15.1255 15.706 13.5566 16.7834 11.7654 17.2166C9.97428 17.6498 8.08636 17.4084 6.46185 16.5384C4.83733 15.6685 3.58995 14.231 2.95768 12.5001M2.54102 16.6667V12.5001H6.70768"
                stroke="#222222"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>Recent searches</span>
          </div>
          <div
            className="clear-all"
            onClick={() => {
              // console.log("clear all");
              close();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M16.2421 6.34383C16.6326 5.9533 17.2658 5.9533 17.6563 6.34383C18.0468 6.73435 18.0468 7.36751 17.6563 7.75804L7.75683 17.6575C7.36631 18.0481 6.73314 18.0481 6.34262 17.6575C5.95209 17.267 5.95209 16.6338 6.34262 16.2433L16.2421 6.34383Z"
                fill="#6E6E70"
              />
              <path
                d="M17.6562 16.246C18.0467 16.6365 18.0467 17.2697 17.6562 17.6602C17.2657 18.0508 16.6325 18.0508 16.242 17.6602L6.34247 7.76074C5.95194 7.37021 5.95194 6.73705 6.34247 6.34652C6.73299 5.956 7.36616 5.956 7.75668 6.34652L17.6562 16.246Z"
                fill="#6E6E70"
              />
            </svg>
          </div>
        </div>
       { loading
        ? 
        <div style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}><Skeleton paragraph={{ rows: 1 }} active /></div> 
        : 
        <div className="top-searches-itemBox">
          {history.map((item, index) => (
            <div className="item cursor-pointer" onClick={() => {
              // console.log('item: ', item)
              // apply params to searchFields
              applyParams(item.parameters)
            }}>
              <div className={`purpose-tag ${purposeTag(item.purpose)}`}>
                <span>{item.purpose === "Purchase" ? "Purchase" : item.purpose === "RateTermRefi" ? "Refinance" : "Cash Out"}</span>
              </div>
              <div className="item-content">
                <div className="occupancy">
                  <span>{formatOccupancy(item.occupancy)}</span>
                </div>
                <div className="property-value">
                  <span>${(item.propertyValue || getPropertyValue(item)) / 1000}K</span> {/* 如果propertyValue为空，则使用loanAmount/LTV */}
                </div>
                <div className="fico">
                  <span>FICO: {item.fico}</span>
                </div>
                <div className="ltv">
                  <span>{item.ltv ? item.ltv.toFixed(2) : '0'}% LTV</span>
                </div>
              </div>
              <>
                <div className="time_and_action">
                  <span className="time">{formatTime(item.createdTime)}</span>
                  <span className="edit-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="7"
                      height="10"
                      viewBox="0 0 7 10"
                      fill="none"
                    >
                      <rect
                        width="10"
                        height="7"
                        transform="matrix(0 -1 1 0 0 10)"
                        fill="#F3F4F6"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.82261 0.0445795L0.894531 0.972656L4.91567 4.9938L0.896142 9.01333L1.82422 9.94141L5.84375 5.92188L5.84428 5.9224L6.77236 4.99433L6.77183 4.9938L6.77397 4.99166L5.84589 4.06358L5.84375 4.06572L1.82261 0.0445795Z"
                        fill="#222222"
                      />
                    </svg>
                  </span>
                </div>
              </>
            </div>
          ))}
        </div>
       }
      </div>
    )
  );
};

export default TopSearches;
